import Header from 'src/components/organisms/header/Header';
import DefaultTemplate from 'src/components/templates/default-template/DefaultTemplate';
import PromoBannerSection from 'src/components/organisms/promo-banner-section/PromoBannerSection';
import ChallengesSection from 'src/components/organisms/challenge-section/ChallengesSection';
import CardActivitiesCarousel from 'src/components/organisms/card-activities-carousel/CardActivitiesCarousel';
import RewardsSection from 'src/components/organisms/rewards-section/RewardsSection';
import DailyHabitsSection from 'src/components/organisms/daily-habits-section/DailyHabitsSection';
import HealthTrackersSection from 'src/components/organisms/health-trackers-section/HealthTrackersSection';
import ThingsImWorkingOnSection from 'src/components/organisms/things-im-working-on-section/ThingsImWorkingOnSection';
import Footer from 'src/components/organisms/footer/Footer';
import HealthGoalsSection from 'src/components/organisms/health-goals-section/HealthGoalsSection';
import { useDashboardStyles } from './Dashboard.styles';

const workingElement = <ThingsImWorkingOnSection />;

const footerElement = <Footer />;

const Dashboard = (): JSX.Element => {
  const styles = useDashboardStyles();
  return (
    <DefaultTemplate header={<Header />} preFooter={workingElement} footer={footerElement}>
      <div className={styles.banner}>
        <PromoBannerSection />

        <CardActivitiesCarousel />
      </div>

      <div className={styles.container}>
        <ChallengesSection />

        <RewardsSection />

        <DailyHabitsSection />

        <HealthTrackersSection />

        <HealthGoalsSection />
      </div>

    </DefaultTemplate>
  );
};

export default Dashboard;
